import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import ExternalLayoutComponent from './external-layout.component';
import ExternalHeaderComponent from './external-header/external-header.component';

const externalLayout = angular
  .module('tst.external-layout', [
    uiRouter
  ])
  .component('externalLayout', ExternalLayoutComponent)
  .component('externalHeader', ExternalHeaderComponent)
  .config(function ($stateProvider) {
    'ngInject';

    $stateProvider

      .state('external', {
        abstract: true,
        data: {
          //authRequired: true
        },
        views: {
          '': {
            component: 'externalLayout'
          }
        }

      });
  })
  .name;

export default externalLayout;




// WEBPACK FOOTER //
// ./client/app/layout/external-layout/index.js